import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ResponsiveModule } from 'ngx-responsive';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ButtonsComponent } from './components/buttons/buttons.component';
import { BasicDatatableComponent } from './components/datatables/basic-datatable.component';
import { IconComponent } from './components/icon/icon.component';
import { LanguageSwitchComponent } from './components/language-switch/language-switch.component';
import { BannerComponent } from './components/layout/banner/banner.component';
import { FooterComponent } from './components/layout/footer/footer.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { MenuComponent } from './components/menu/menu.component';
import { ResetButtonComponent } from './components/reset-button/reset-button.component';
import { ResetSaveComponent } from './components/reset-save/reset-save.component';
import { SaveButtonComponent } from './components/save-button/save-button.component';
import { SpinnerButtonComponent } from './components/spinner-button/spinner-button.component';
import { TranslateCutPipe } from './pipes/translate-cut.pipe';
import { EscapeHtmlPipe } from './pipes/keep-html.pipe';
import { DatatablePagerComponent } from './components/datatable-pager/datatable-pager.component';
import { LoaderComponent } from './components/loader/loader.component';
import { DateTransformPipe } from './pipes/date-transform.pipe';
import { DatatableLinesPerPageComponent } from './components/datatable-rows-per-page/datatable-rows-per-page.component';
import { CfeDatatableComponent } from './components/datatable/datatable.component';
import { ScrollTopComponent } from './components/scroll-top/scroll-top.component';
import { HeroBannerComponent } from './components/hero-banner/hero-banner.component';
import { EllipsedTooltipDirective } from './directives/ellipsed-tooltip.directive';
import { DsTooltipDirective } from './directives/ds-tooltip.directive';
import { StatusTableComponent } from './components/status-table/status-table.component';
@NgModule({
	imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, NgbModule, NgxDatatableModule, ResponsiveModule, RouterModule],
	providers: [],
	declarations: [
		// Components
		FooterComponent,
		HeaderComponent,
		BannerComponent,
		MenuComponent,
		SpinnerButtonComponent,
		IconComponent,
		BasicDatatableComponent,
		ButtonsComponent,
		LanguageSwitchComponent,
		BreadcrumbComponent,
		ResetButtonComponent,
		ResetSaveComponent,
		SaveButtonComponent,
		DatatablePagerComponent,
		DatatableLinesPerPageComponent,
		LoaderComponent,
		CfeDatatableComponent,
		ScrollTopComponent,
		HeroBannerComponent,
		StatusTableComponent,

		// Pipes
		TranslateCutPipe,
		DateTransformPipe,
		EscapeHtmlPipe,

		// Directives
		EllipsedTooltipDirective,
		DsTooltipDirective
	],
	exports: [
		// Components
		FooterComponent,
		HeaderComponent,
		BannerComponent,
		MenuComponent,
		SpinnerButtonComponent,
		IconComponent,
		BasicDatatableComponent,
		ButtonsComponent,
		BreadcrumbComponent,
		LanguageSwitchComponent,
		ResetButtonComponent,
		ResetSaveComponent,
		SaveButtonComponent,
		DatatablePagerComponent,
		DatatableLinesPerPageComponent,
		CfeDatatableComponent,
		LoaderComponent,
		HeroBannerComponent,
		StatusTableComponent,

		// Pipes
		TranslateCutPipe,
		DateTransformPipe,
		EscapeHtmlPipe,

		// Modules
		NgxDatatableModule,
		ResponsiveModule,

		// Directives
		EllipsedTooltipDirective,
		DsTooltipDirective
	]
})
export class SharedModule {}
